import { Injectable } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { TeamService } from '../service/team.service';

@Injectable({
    providedIn: 'root'
})
export class TeamValidators
{
    constructor(private teamService: TeamService) { }

    public validateTeamRoleNameUnique(control: UntypedFormControl, initialName: string): any
    {
        return new Promise(resolve =>
        {
            if (control !== null && initialName !== control.value)
            {
                this.teamService.existsTeamRoleName(control.value).subscribe({
                    next: (response) =>
                    {
                        if (response)
                        {
                            resolve({ nameExists: true });
                        }
                        else
                        {
                            resolve(null);
                        }
                    }
                });
            }
            else
            {
                resolve(null);
            }
        });
    }
}
